export default __webpack_public_path__ + "static/media/Thief's Leggings of the Sundered Crown.a9be7312.jpg";